import React, { useContext } from 'react'
import {
    Routes,
    Route,
    Link
  } from "react-router-dom";
import MyButton from './button/MyButton';
import About from '../../pages/About';
import Models from '../../pages/Models';
import ModelIdPage from '../../pages/ModelIdPage' 
import { publicRoutes, privateRoutes } from '../../router/index';
import Login from '../../pages/Login';
import { AuthContext } from '../../context';

function AppRouter() {
  const {isAuth, setIsAuth} = useContext(AuthContext)
  return(
    isAuth
      ? 
      <Routes>
          <Route path="about" element={<About />} />
          <Route exact path="models" element={<Models />} />
          <Route path="models/:id" element={<ModelIdPage />} /> 
          <Route path="*" element={<Models />} />
          
          {/* 
          {privateRoutes.map(route => 
           <Route key={route.path} path={route.path} element={`<${route.component} />`} exact={route.exact} />
           )} 
           */}
      </Routes>
          
      :
      <Routes>
        <Route exact path="login" element={<Login />} />
        <Route path="*" element={<Login />} />
        {/* 
        {publicRoutes.map(route => 
           <Route key={route.path} path={route.path} element={`<${route.component} />`} exact={route.exact} />
        )}  
        */}
      </Routes>

      // Вариант для отображения ошибки 404
        //  <Route path="*" element={
        //     <div style={{ padding: "1rem" }}>
        //       <p>404: There's nothing here!</p> <br/>
        //       <Link to='/models'><MyButton>Go to Models page</MyButton></Link>
        //     </div>
        //   }
        // /> 
  )
}

export default AppRouter